import { Logger, LoggerFactory } from './../logger.service';
import { Language, UserIdentity } from './user-identity';
import { EventEmitter, Inject, Injectable } from '@angular/core';
import { IMtr } from '../tracker/mtr.interface';
import { CurrentUserService } from './current-user.service';

// User identity factory
@Injectable()
export class IdentityProviderService {
  public onIdentityChanged = new EventEmitter<UserIdentity>();

  private lastIdentityJson: string | undefined;
  private lastIdentity: UserIdentity | undefined;
  private updateInFlight = false;
  private logger: Logger;

  constructor(
    private readonly currentUserService: CurrentUserService,
    @Inject('Mtr') private readonly mtr: IMtr,
    public loggerFactory: LoggerFactory,
  ) {
    this.logger = loggerFactory.get('IdentityProviderService');
  }

  public notifyPossibleIdentityUpdate(): void {
    if (this.updateInFlight) return;
    this.updateInFlight = true;
    this.doUpdateAsync().finally(() => {
      this.updateInFlight = false;
    });
  }

  public async loadInitialIdentityAsync(): Promise<void> {
    await this.doUpdateAsync();
  }

  public clearIdentity(): void {
    this.lastIdentityJson = undefined;
    this.lastIdentity = undefined;
  }

  private async doUpdateAsync(): Promise<void> {
    const identity = await this.currentUserService.loadFromServer();
    const identityJson = identity ? JSON.stringify(identity) : undefined;
    if (identityJson === this.lastIdentityJson) return;

    this.lastIdentityJson = identityJson;
    this.lastIdentity = identity;

    if (identity) {
      this.mtr.setCustomData('email', identity.email);
    }
    this.onIdentityChanged.emit(identity);
  }

  public get currentIdentity(): UserIdentity {
    return this.lastIdentity;
  }
}
